module.exports = __webpack_public_path__ + "img/B9896A_5B341B_F4CAA3_6C4C2D-256px.c4f8a7b0.png";